import React from 'react'
import PropTypes from 'prop-types'

import ListingDetailRatings from 'syft-acp-core/entities/ListingRatings/ListingRatings'
import PageTitle from 'syft-acp-core/components/PageTitle'

const ListingRatings = ({ match: { params } }) => {
  // 'Worker info' is what the listing sub-navigation calls this tab.
  const title = ['Worker info', `Listing ${params.id}`]
  if (params.jobID) title.push(`job ${params.jobID}`)
  if (params.shiftID) title.push(`shift ${params.shiftID}`)

  return (
    <PageTitle title={title}>
      <ListingDetailRatings
        id={Number(params.id)}
        jobID={params.jobID ? Number(params.jobID) : 0}
        shiftID={params.shiftID ? Number(params.shiftID) : 0}
      />
    </PageTitle>
  )
}

ListingRatings.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }),
}

export default ListingRatings
